












































































































































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import uniq from 'lodash/uniq';
import XLSX from 'xlsx';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'ds', 'data', 'filter'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX', 'exportDataAsPDF'
    ])
  },
  components: {
    TitleBar
  }
})
export default class PlaningReport extends Vue {

  opened: any[] = [];
  ds!: any[];
  filter!: any;
  get dateMoment () {
    return moment().date()
  }
  get allowPrev () {
    return this.$route.query.prev
  }

  get titleStack () {
    return [
      'Отчеты',
      'По планированию'
    ]
  }
  get selectedView() {
    return this.$route.params.view || 'weight'
  }

  setParams(filterName: string, filterValue: any) {
    //@ts-ignore
    this.localFilter[filterName] = filterValue
  }

  localFilter = {
    employeeId: null,
    targetDate: new Date(),
    new_only: false,
    with_hidden: false,
    new: false,
    view: 'weight',
    no_group: false
  }
  tableToExcel() {
    this.$store.dispatch(`${STORE_KEY}/exportData`, {is_new: this.filter.new}).then((csvContent: any[]) => {
      const ws = XLSX.utils.aoa_to_sheet(csvContent);
      const _border_idx = csvContent.map((i: any, idx: any) => {
        return [!i.length, idx] 
      }).filter((item: any) => {
        return item[0]
      })[0][1] + 2
      console.log('bix', _border_idx, csvContent)
      // @ts-ignore
      const range = XLSX.utils.decode_range(ws['!ref']);
      for(let R = range.s.r; R <= range.e.r; ++R) {
        const _b = R > _border_idx ? 4 : 2
        for(let C = range.s.c; C <= range.e.c; ++C) {
          const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
          if(!ws[cellref] || C < _b || R < 1 || R == _border_idx + 1) continue; // if cell doesn't exist, move on
          const cell = ws[cellref];
          if (_border_idx < R) {
            console.log(C, R, cell)
          }
          cell.t = 'n'
          cell.z = '0.00'
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Отчет");
      XLSX.writeFile(wb, 'export.xlsx')
    })
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.client_id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.client_id != row.client_id)
      );
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.employeeId = (this.$route.query && this.$route.query.employeeId)? this.$route.query.employeeId : null;
    // @ts-ignore
    this.localFilter.targetDate = (this.$route.query && this.$route.query.targetDate) ? moment(this.$route.query.targetDate).toDate() : null;
    // @ts-ignore
    this.localFilter.new_only = (this.$route.query && this.$route.query.new_only) ? this.$route.query.new_only : null;
    // @ts-ignore
    this.localFilter.with_hidden = (this.$route.query && this.$route.query.with_hidden) ? this.$route.query.with_hidden : null;
    // @ts-ignore
    this.localFilter.new = (this.$route.query && this.$route.query.new) ? this.$route.query.new : null;
    // @ts-ignore
    this.localFilter.no_group = (this.$route.query && this.$route.query.no_group)? this.$route.query.no_group == 'true' : null;

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDate') ? moment(this.localFilter[key]).format('YYYY-MM-DD') : this.localFilter[key]
      return ac;
    }, {});1

    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.$route.params, ...this.$route.query
      });
  }

}
